import { render, staticRenderFns } from "./HouseCard.vue?vue&type=template&id=28d2a56c&scoped=true&"
import script from "./HouseCard.vue?vue&type=script&lang=js&"
export * from "./HouseCard.vue?vue&type=script&lang=js&"
import style0 from "./HouseCard.vue?vue&type=style&index=0&id=28d2a56c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d2a56c",
  null
  
)

component.options.__file = "HouseCard.vue"
export default component.exports